module.exports = __webpack_public_path__ + "static/media/notification.10a7537f.svg";